module.exports = __webpack_public_path__ + "media/sarah.be989e8f.mp4";